export default __webpack_public_path__ + "static/media/3031 spice rack F side.fb90f9f5.png";